import type { TrendItemContentTweetsItemReferencedTweetTweetAuthor } from './trendItemContentTweetsItemReferencedTweetTweetAuthor';
import type { TrendItemContentTweetsItemReferencedTweetTweetBasicInfo } from './trendItemContentTweetsItemReferencedTweetTweetBasicInfo';
import type { TrendItemContentTweetsItemReferencedTweetTweetEngagement } from './trendItemContentTweetsItemReferencedTweetTweetEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export type TrendItemContentTweetsItemReferencedTweetTweet = {
  /** 트윗 작성자 정보 */
  author?: TrendItemContentTweetsItemReferencedTweetTweetAuthor;
  basicInfo?: TrendItemContentTweetsItemReferencedTweetTweetBasicInfo;
  engagement?: TrendItemContentTweetsItemReferencedTweetTweetEngagement;
};
